/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Faq_Q1Inputs */

const en_to_typescript_faq_q1 = /** @type {(inputs: To_Typescript_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are the generated interfaces accurate?`)
};

const ko_to_typescript_faq_q1 = /** @type {(inputs: To_Typescript_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생성된 인터페이스는 정확한가요?`)
};

const ja_to_typescript_faq_q1 = /** @type {(inputs: To_Typescript_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成されたインターフェースは正確ですか？`)
};

/**
* | output |
* | --- |
* | "Are the generated interfaces accurate?" |
*
* @param {To_Typescript_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_faq_q1 = /** @type {((inputs?: To_Typescript_Faq_Q1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Faq_Q1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_faq_q1(inputs)
	if (locale === "ko") return ko_to_typescript_faq_q1(inputs)
	return ja_to_typescript_faq_q1(inputs)
});